/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { CountPendingAssistantProposalsQueryResponse, CountPendingAssistantProposalsPathParams, CountPendingAssistantProposalsQueryParams, CountPendingAssistantProposals400, CountPendingAssistantProposals401, CountPendingAssistantProposals403, CountPendingAssistantProposals404, CountPendingAssistantProposals409, CountPendingAssistantProposals500 } from "../../types/assistantProposalsController/CountPendingAssistantProposals.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { countPendingAssistantProposals } from "../../client/assistantProposalsController/countPendingAssistantProposals.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const countPendingAssistantProposalsQueryKey = (organizationId: CountPendingAssistantProposalsPathParams["organizationId"] | undefined, params?: CountPendingAssistantProposalsQueryParams) => [{ url: '/api/organizations/:organizationId/assistant-proposals/counts', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type CountPendingAssistantProposalsQueryKey = ReturnType<typeof countPendingAssistantProposalsQueryKey>

export function countPendingAssistantProposalsQueryOptions(organizationId: CountPendingAssistantProposalsPathParams["organizationId"] | undefined, params?: CountPendingAssistantProposalsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = countPendingAssistantProposalsQueryKey(organizationId, params)
        return queryOptions<CountPendingAssistantProposalsQueryResponse, ResponseErrorConfig<CountPendingAssistantProposals400 | CountPendingAssistantProposals401 | CountPendingAssistantProposals403 | CountPendingAssistantProposals404 | CountPendingAssistantProposals409 | CountPendingAssistantProposals500>, CountPendingAssistantProposalsQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return countPendingAssistantProposals(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Pending assistant-proposal count (farm-scoped)
 * {@link /api/organizations/:organizationId/assistant-proposals/counts}
 */
export function useCountPendingAssistantProposals<TData = CountPendingAssistantProposalsQueryResponse, TQueryData = CountPendingAssistantProposalsQueryResponse, TQueryKey extends QueryKey = CountPendingAssistantProposalsQueryKey>(organizationId: CountPendingAssistantProposalsPathParams["organizationId"] | undefined, params?: CountPendingAssistantProposalsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<CountPendingAssistantProposalsQueryResponse, ResponseErrorConfig<CountPendingAssistantProposals400 | CountPendingAssistantProposals401 | CountPendingAssistantProposals403 | CountPendingAssistantProposals404 | CountPendingAssistantProposals409 | CountPendingAssistantProposals500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? countPendingAssistantProposalsQueryKey(organizationId, params)
         

         const query = useQuery({
          ...countPendingAssistantProposalsQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<CountPendingAssistantProposals400 | CountPendingAssistantProposals401 | CountPendingAssistantProposals403 | CountPendingAssistantProposals404 | CountPendingAssistantProposals409 | CountPendingAssistantProposals500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}